/**
	* Licensed Materials - Property of IBM
	* IBM Watson Analytics (C) Copyright IBM Corp. 2017
	* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
	*/
define(['./FilterTypes'], function (FilterTypes) {
	'use strict';

	var table = {};

	table['filterDock'] = {};

	//TODO: localfilter dialog controller implementation and paths are now controlled by dataFilters feature.
	//		We should be able to remove this file altogether once filtersUI is enabled.
	table['filterDock'][FilterTypes.RANGE] = { 'path': 'dashboard-analytics/filters/controls/RangeFilterController' };
	table['filterDock'][FilterTypes.TREE] = { 'path': 'dashboard-analytics/filters/controls/HierarchicalFilterController' };
	table['filterDock'][FilterTypes.NON_NUMERICAL] = { 'path': 'dashboard-analytics/filters/controls/NonNumericFilterController' };
	table['filterDock'][FilterTypes.DATE_TIME] = { 'path': 'dashboard-analytics/filters/controls/DateTimeFilterController' };

	return table;
});
